import loadable from '@loadable/component';

export default loadable(() => import(/* webpackChunkName: "CommonPDPRegular" */ './Regular'), {
    fallback: null,
});
